<div
  class="pagination d-flex align-items-center justify-content-center w-100 my-3"
  [ngClass]="{ 'd-none': allPagesNumber() === 1 || !allPagesNumber() }"
>
  <mwe-button
    class="mx-4 btn-bubble"
    size="md"
    category="primary"
    [isIconBtn]="true"
    (clicked)="onPreviousPage()"
    [disabled]="currentPage() === 1"
    [attr.data-test]="dataTest() + '-pagination-previous'"
  >
    <i class="fas fa-chevron-left"></i>
  </mwe-button>
  <div class="fw-semibold" [attr.data-test]="dataTest() + '-pagination-current'">{{ currentPage() }}</div>
  <div class="fw-semibold px-6">von</div>
  <div [attr.data-test]="dataTest() + '-pagination-total'">{{ allPagesNumber() }}</div>
  <mwe-button
    class="mx-4 btn-bubble"
    size="md"
    category="primary"
    [isIconBtn]="true"
    (clicked)="onNextPage()"
    [disabled]="currentPage() === allPagesNumber()"
    [attr.data-test]="dataTest() + '-pagination-next'"
  >
    <i class="fas fa-chevron-right"></i>
  </mwe-button>
</div>
